module.exports = __webpack_public_path__ + "static/buttondown-0007cf27b53fdbfcb23d02f0047dab3c.jpg";